import React from "react"
import autobind from "class-autobind"
import ImageLoader from "../../../../components/misc/ImageLoader"
import ToolTip from "react-portal-tooltip"
import strings from "../../../../localization/strings"
import User from "material-ui/svg-icons/action/account-circle"
import { ISchedulePatternTemplate } from "../../../../models"
interface IProps {
    patternTemplate: ISchedulePatternTemplate
}
interface IState {
    open: boolean
}

export default class AssignedEmployeeInfoToolTipIcon extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="right"
                    arrow="center"
                    parent={"#" + "image-" + this.props.patternTemplate.Id}
                    key={this.props.patternTemplate.Id}
                    group={"image-" + this.props.patternTemplate.Id}
                    tooltipTimeout={50}
                >
                    <div style={{ color: "rgb(97, 97,97)", fontSize: 15, fontWeight: 500, textAlign: "center", padding: 5 }}>{strings.Assigned_Employee}</div>
                    {this.props.patternTemplate.AssignedUserProfileImageS3Url &&
                        <div style={{ height: 100, minWidth: 75, textAlign: "center" }}>
                            <ImageLoader url={this.props.patternTemplate.AssignedUserProfileImageS3Url} fixedHeight={100} />
                        </div>
                    }
                    <div style={{ textAlign: "center" }}>{this.props.patternTemplate.AssignedUserName}</div>
                    {this.props.patternTemplate.AssignedUserExternalId &&
                        <div style={{ textAlign: "center" }}>{this.props.patternTemplate.AssignedUserExternalId}</div>
                    }
                </ToolTip>
                <span onMouseOver={() => this.setState({ open: true })} onMouseOut={() => this.setState({ open: false })} id={"image-" + this.props.patternTemplate.Id}>
                    <User style={{ color: "white", width: 18, height: 18, marginTop: 3, marginLeft: 3, marginRight: -5 }} />
                </span>
            </div>
        )
    }
}
